export enum RegistrationType {
    FLOAT = 'FLOAT',
    LOCK = 'LOCK'
}

export const registrationTypeDisplay = {
    [RegistrationType.FLOAT]: 'floated',
    [RegistrationType.LOCK]: 'locked'
};
